import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const Blog = () => {
    return (
        <>
            <Header as="h1" id="blog-header">Blog</Header>
        </>
    );
};

export default Blog;